import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCMollieIn3, type TrydentMollieIn3Data } from './mollie-in3.js'
import { type In3MethodId } from 'components/ordering/checkout/payment-methods/methods/method-ids.js'


type TrydentMollieIn3Response = {
  custom_description: string,
  mollie_data: TrydentMollieIn3Data & { id: In3MethodId }
}

export const parseMollieIn3 = (value: unknown, selectedPaymentMethod: string): CSCMollieIn3 | typeof CouldNotParse => {
  if (is<TrydentMollieIn3Response>(value)) {
    const state = value.mollie_data.id === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCMollieIn3(
      value.mollie_data,
      state,
      value.custom_description,
    )
  }
  return CouldNotParse
}
